// extracted by mini-css-extract-plugin
module.exports = {"component":"styles-member-info__component--eaUmY"};